module.exports = __webpack_public_path__ + "static/media/11.4e3283c6.png";